import isEmpty from '../../../Shared/Utils/isEmpty';

const ONE_SECOND_IN_MS = 1000;

const subscribeToPlaybackApiResponse = (
    playbackApiResponse$,
    resumePointsStore,
) =>
    playbackApiResponse$
        .subscribe(playbackResponse => {
            const resumePoints = playbackResponse && playbackResponse.resumePoints;

            if (isEmpty(resumePoints))  {
                return resumePointsStore.actions.disableFeature();
            }

            const { updateInterval, resumeFrom } = resumePoints;
            resumePointsStore.actions.updateResumePoints({
                updateIntervalMs: updateInterval * ONE_SECOND_IN_MS,
                resumeFrom,
                isEnabled: true,
            });
        });

export default subscribeToPlaybackApiResponse;
